import { render, staticRenderFns } from "./TaskFilterBar.vue?vue&type=template&id=bedad976&scoped=true"
import script from "./TaskFilterBar.vue?vue&type=script&lang=js"
export * from "./TaskFilterBar.vue?vue&type=script&lang=js"
import style0 from "./TaskFilterBar.vue?vue&type=style&index=0&id=bedad976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedad976",
  null
  
)

export default component.exports